import { useEffect } from "react";
import { reportError } from "src/services/errorReporting";

const useSentryReplayHook = () => {
  useEffect(() => {
    // Replay loads as its own chunk. If the app unmounts (for example on logout)
    // before it arrives, skip adding it.
    let cancelled = false;

    import("./addReplayIntegration")
      .then((module) => {
        if (!cancelled) {
          module.default();
        }
      })
      .catch(reportError);

    return () => {
      cancelled = true;
    };
  }, []);
};

export default useSentryReplayHook;
